var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgExcelemation(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_1778",
    "data-name": "Group 1778",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 23.193,
    height: 21.909,
    viewBox: "0 0 23.193 21.909",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_743",
    "data-name": "Rectangle 743",
    width: 23.193,
    height: 21.909,
    fill: "#f04d4d"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1777",
    "data-name": "Group 1777",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1408",
    "data-name": "Path 1408",
    d: "M11.592,21.9c-2.706,0-5.412.009-8.118,0A3.377,3.377,0,0,1,.007,18.3a3.677,3.677,0,0,1,.43-1.459Q4.486,9.323,8.58,1.828A3.262,3.262,0,0,1,11.6,0a3.257,3.257,0,0,1,3.017,1.83q4.059,7.463,8.113,14.928A3.4,3.4,0,0,1,19.71,21.9c-2.706.021-5.412,0-8.118,0M10.236,9.636c0,.891-.007,1.782,0,2.673a1.36,1.36,0,1,0,2.716-.015q.012-2.65,0-5.3a1.361,1.361,0,1,0-2.717.015c-.007.876,0,1.752,0,2.627M11.613,15.1a2.027,2.027,0,0,0-2.053,2.028,2.037,2.037,0,0,0,4.073.032,2.024,2.024,0,0,0-2.02-2.06",
    transform: "translate(0 0)",
    fill: "#f04d4d"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExcelemation);
export default __webpack_public_path__ + "static/media/excelemation.6d0ca390cb038f8ab10f08ffed9322a4.svg";
export { ForwardRef as ReactComponent };